import { Card, Divider, Flex } from 'antd';
import Loader from 'components/CustomLoader/index';
import NoData from 'components/NoData';
import Tag from 'components/Tags/index';
import TaskInfo from 'components/TaskInfo';
import { STATUS } from 'utils/constants';
import { getStatusValues, renderDate } from 'utils/helpers';
// import './style.scss';
import { useTranslation } from 'react-i18next';
import useMrvQuery from 'screens/awd-dashboard/hooks/queries/useMrvQuery';
import { SelectTaskData } from 'screens/sales-group-progress';
import PipeInstallationAccordion from './pipe-accordion/PipeInstallationAccordion';

function PipeInstallationContent({ data }: { data: SelectTaskData }) {
  const { task, season } = { ...data };
  const { numberOfPipes, numberOfInstalledPipes } = { ...season };

  const { t } = useTranslation();

  let status = task?.status;
  if (
    status === STATUS.UPCOMING &&
    new Date() > new Date(task?.dueDate ?? '')
  ) {
    status = STATUS.OVERDUE;
  }
  const { text: iconText, color: iconColor } = getStatusValues(status);

  const { data: mrvData, isLoading } = useMrvQuery(season?.id);

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <Loader size="medium" />
        </div>
      ) : (
        <>
          <Card>
            <Flex wrap="wrap" style={{ rowGap: 10 }}>
              <TaskInfo
                header={t('dashboard.installationStatus')}
                value={<Tag label={iconText} color={iconColor} />}
              />
              <TaskInfo
                header={t('dashboard.expectedPipesInstalled')}
                value={numberOfPipes}
              />
              <TaskInfo
                header={t('dashboard.pipesInstalled')}
                value={numberOfInstalledPipes}
              />
              <TaskInfo
                header={t('dashboard.taskCompletionDate')}
                value={renderDate(task?.inputDate)}
              />
            </Flex>
          </Card>
          <Divider />
          {mrvData && mrvData?.data?.length === 0 ? (
            <NoData message={t('dashboard.noPipesInstalled')} />
          ) : (
            <Flex vertical gap={8}>
              {mrvData?.data?.map((pipe, index) => (
                <PipeInstallationAccordion
                  key={`pipeInstallationAccordion-${index + 1}`}
                  data={data}
                  pipeData={pipe}
                  index={index}
                />
              ))}
            </Flex>
          )}
        </>
      )}
    </>
  );
}

export default PipeInstallationContent;
